const updateBookingRemarksToast = (state = null, action) => {
  if (action.type === "SET_UPDATE_BOOKING_REMARKS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_UPDATE_BOOKING_REMARKS_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default updateBookingRemarksToast;
